module.exports = __webpack_public_path__ + "img/aws.b91e5544.svg";